import $ from 'jquery'
import {isV6} from 'scoreboard/components/version'

function setupV6() {
	// Function to apply the v5 class to the body
	window.v5 = function(reload = true) {
		setVersion('v5', reload)
	}

	// Function to apply the v6 class to the body
	window.v6 = function(reload = true) {
		setVersion('v6', reload)
	}

	function setVersion (version, reload) {
		let other = version === 'v5' ? 'v6' : 'v5'
		// Swap the classes on the body
		$('body').removeClass(other).addClass(version)
		// Store the current state in localStorage
		localStorage.setItem('version', version)
		// Also store as a cookie so the server can pick the correct CSS file
		setVersionCookie(version)
		if (reload) {
			location.reload()
		}
	}

	function setVersionCookie (version) {
		// Set to expire in 1 year; we should have the v5 code deleted by then
		let expireDate = new Date()
		expireDate.setTime(expireDate.getTime() + (365 * 24 * 60 * 60 * 1000))

		document.cookie = `impactVersion=${version}`
			+ `; expires=${expireDate.toUTCString()}`
			+ `; path=/; SameSite=Strict`
	}

	// Load the stored version on page load
	$(document).ready(function() {
		// If there is no version stored, default to v5
		if (!isV6()) {
			window.v5(false)
		} else if (isV6()) {
			window.v6(false)
		}
	})
}

export default setupV6

setupV6.__filename__ = 'setup-v6.js'
